const ComingSoon: React.FC = () => {
    return (
        <div className="h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center p-4">
            <div className="max-w-2xl w-full text-center space-y-8">
                <div>
                    <img 
                        src={process.env.PUBLIC_URL + '/Icon-light.png'} 
                        className="h-16 mx-auto flex items-center justify-center"
                        alt="Canso Logo"
                    />
                </div>

                {/* Main heading */}
                <div className="space-y-4">
                    <h1 className="text-4xl md:text-6xl font-bold text-slate-900 tracking-tight">Coming Soon...</h1>
                    {/* <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full"></div> */}
                </div>

                {/* Description */}
                <div className="space-y-6">
                    <p className="text-xl text-slate-600 leading-relaxed max-w-lg mx-auto">
                        We’re working on something awesome. Stay tuned!
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ComingSoon;